import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { useTheme } from "../../../layout/components/ThemeProvider/ThemeProvider";

type Props = {
  className: string;
  svgIcon?: string;
  color?: string;
  change: string;
  description: string;
  data?: any;
};

const SparklineChart: React.FC<Props> = ({ className, data }) => {
  const { lightTheme } = useTheme();
  const layout: Partial<Plotly.Layout> = {
    height: 50,
    margin: { l: 0, r: 0, t: 0, b: 0 },
    xaxis: {
      visible: false,
    },
    yaxis: {
      visible: false,
    },
    showlegend: false,
    plot_bgcolor: "rgba(0,0,0,0)",
    paper_bgcolor: "rgba(0,0,0,0)",
  };

  const [plotData, setPlotData] = useState<Partial<Plotly.PlotData>[]>([
    {
      x: [...data[0].reverse()],
      y: [...data[1].reverse()],
      type: "scatter",
      mode: "lines",
      line: {
        color: lightTheme ? "#06C" : "#78a9ff",
        width: 3,
      },
    },
  ]);

  useEffect(() => {
    setPlotData((prevPlotData) => {
      const newPlotData = [...prevPlotData];
      if (newPlotData[0]?.line) {
        newPlotData[0].line.color = lightTheme ? "#06C" : "#78a9ff";
      }
      return newPlotData;
    });
  }, [lightTheme]);

  return (
    <div
      className={`${className} sparkline-chart w-100  ${
        lightTheme ? "lightCard" : "darkCard"
      }`}
    >
      <div className=" w-100 p-0">
        <Plot
          config={{
            displaylogo: false,
            responsive: true,
            displayModeBar: false,
          }}
          data={plotData}
          layout={layout}
          style={{ width: "100%", height: 50 }}
        />
      </div>
    </div>
  );
};

export { SparklineChart };
